import { testimonials } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              Depoimentos
            </p>
            <h2 className="mt-3 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
              {testimonials.title}
            </h2>
          </div>
        </Reveal>

        <Reveal>
          <div className="mx-auto mt-10 max-w-2xl rounded-lg border border-dashed border-accent-400/30 bg-background-100 p-10 text-center">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-accent-400/30 bg-background-50">
              <i className="ri-chat-quote-line text-accent-400 text-2xl" />
            </span>
            <p className="mt-5 text-sm leading-relaxed text-foreground-400">
              {testimonials.placeholder}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}